import CurrencyService from './services';
import CurrencyTypes from './types';

export const listCurrency = () => CurrencyTypes.list.createAction(() => CurrencyService.listCurrency());
